import * as tool from '../api/common';

const  getters =  {
    get_socket_id: function (state) {
      return state.socket_id;
    },
    get_uid_id: function (state) {
      return state.u_id;
    },

    get_userinfo: (state) => (uid) => {
      var info = {
        'uid': uid,
        'photo': '',
        'nick': '',
        'sex': '',
        'age_range': '',
        'loc_province': ''
      }
      var userinfo = state.userinfo;
      var idx = tool.hasKey(userinfo, uid, 'uid');
      if(idx >= 0)
      {
        info = userinfo[idx];
      }
      return info;
    }
  };

  export default getters;